
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

import Vue from 'vue';
import 'promise-polyfill/src/polyfill';

let tooltipInit = () => {
    $(function () {
        $('[data-toggle="tooltip"]').tooltip()
    });
    Vue.directive('tooltip', function(el, binding){
        $(el).tooltip({
            title: binding.value,
            placement: binding.arg,
            trigger: 'hover'
        })
    });
};

tooltipInit();



